<script setup lang="ts">
import CustomerManagementView from "@/views/playground/planner/business-management/customer-management/CustomerManagementView.vue";
</script>

<template>
  <customer-management-view></customer-management-view>
</template>

<style scoped></style>
